import { CustomMapComponent } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { ScrollableDialogPropsProps } from '@/shared/components/ui/Dialogs/ScrollableDialogProps/ScrollableDialogProps';
import { Naps } from '@/shared/interfaces';

export type MapModalComponentProps = ScrollableDialogPropsProps & {
  coords: string;
  napsData?: Naps[];

  contentNodeOverride?: React.ReactNode;

  canDragMarker?: boolean;
  canRuler?: boolean;
};

const MapModalComponent: React.FC<MapModalComponentProps> = ({
  coords,
  napsData,

  title = 'Ubicación',
  open,
  onClose,
  cancelTextBtn = 'Cerrar',

  contentNodeOverride = null,
  canDragMarker = false,
  canRuler = false,
}) => {
  return (
    <>
      <ScrollableDialogProps
        title={title}
        open={!!open}
        onClose={onClose}
        cancelTextBtn={cancelTextBtn}
        contentNode={
          <>
            {!contentNodeOverride ? (
              <CustomMapComponent
                coordenadas={
                  coords
                    ? {
                        lat: +coords.split(',')[0],
                        lng: +coords.split(',')[1],
                      }
                    : { lat: 0, lng: 0 }
                }
                napsByCity={napsData || []}
                canRuler={canRuler}
                canDragMarker={canDragMarker}
              />
            ) : (
              contentNodeOverride
            )}
          </>
        }
      />
    </>
  );
};

export default MapModalComponent;
